module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.81bd542.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sapporo/font/notokr-medium.woff
// module id = KWfk
// module chunks = 0